import React from 'react';
import { ZfStack, ZfTypography, ZfPill, ZfTextButton } from '@zafire/react';
import ContactNote from 'types/ContactNote';

type LinkedNotesProps = {
  notes: ContactNote[];
  onDelete?: (id: string) => void;
  onClear?: () => void;
  allowUnlink: boolean;
};

export const LinkedNotes: React.FC<LinkedNotesProps> = ({ notes, onDelete, onClear, allowUnlink }) => {
  if (notes.length === 0) {
    return null;
  }

  return (
    <ZfStack
      spacing="small"
      direction="row"
      style={{
        paddingBottom: 'var(--gap-vertical-xs)',
        paddingTop: 'var(--gap-vertical-xs)',
        alignItems: 'center',
        paddingLeft: 'var(--gap-vertical-md)',
        paddingRight: 'var(--gap-vertical-md)',
        border: '1px solid #E0E1EB',
        borderBottom: 'none',
      }}
    >
      <ZfTypography variant="label-small" color="muted">
        {notes.length} selected
      </ZfTypography>
      <ZfStack direction="row" spacing="extra-small" style={{ flexWrap: 'wrap' }}>
        {notes.map((note: ContactNote) => {
          const isDeletable = note.linkingStatus === 'pending' || allowUnlink;
          return (
            <ZfPill
              key={note.contactNoteId}
              deletable={isDeletable}
              onPillDelete={() => onDelete?.(note.contactNoteId!)}
              color={isDeletable ? 'primary' : 'neutral'}
              variant="solid"
            >
              {note.contactNoteId}
            </ZfPill>
          );
        })}
      </ZfStack>
      <ZfTextButton size="extra-small" hierarchy="tertiary" onClick={onClear}>
        Clear
      </ZfTextButton>
    </ZfStack>
  );
};
